<div class="auth-flow" [ngStyle]="contentStyle">
  <h2 class="auth-flow__title typog-lg">{{ title }}</h2>

  <div *ngIf="succeeded" class="auth-flow__panel" role="status">
    <p>You are signed in. Taking you to your account…</p>
  </div>

  <div *ngIf="deadEndMessage" class="auth-flow__panel auth-flow__panel--dead-end" role="alert" tabindex="-1">
    <p>{{ deadEndMessage }}</p>
    <button type="button" class="secondaryButton" [disabled]="busy" (click)="onRestart()">Start again</button>
  </div>

  <ng-container *ngIf="step as current">
    <div
      *ngIf="errorMessage"
      class="auth-flow-error auth-flow__panel auth-flow__panel--error"
      role="alert"
      tabindex="-1"
    >
      {{ errorMessage }}
    </div>

    <p *ngIf="maskedDestination" class="auth-flow__hint">
      We sent a code to <strong>{{ maskedDestination }}</strong
      >.
    </p>

    <div *ngIf="current.type === 'totp_setup'" class="auth-flow__secret">
      <p *ngIf="totpQrDataUrl; else totpSetupHint" class="auth-flow__hint">
        Scan this QR code with your authenticator app, then enter the code it generates. You can also copy
        the setup key or the setup link.
      </p>
      <ng-template #totpSetupHint>
        <p class="auth-flow__hint">
          Add this to your authenticator app, then enter the code it generates — copy the setup key or the
          setup link.
        </p>
      </ng-template>
      <div *ngIf="totpQrDataUrl" class="auth-flow__qr">
        <img [src]="totpQrDataUrl" alt="QR code for setting up your authenticator app" />
      </div>
      <div *ngIf="totpSecret" class="auth-flow__secret-row">
        <code>{{ totpSecret }}</code>
        <button type="button" class="tertiaryButton" (click)="copyValue(totpSecret)">Copy key</button>
      </div>
      <div *ngIf="totpAuthUri" class="auth-flow__secret-row">
        <code class="auth-flow__secret-uri">{{ totpAuthUri }}</code>
        <button type="button" class="tertiaryButton" (click)="copyValue(totpAuthUri)">Copy link</button>
      </div>
    </div>

    <form class="auth-flow-form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <label class="auth-flow__field" *ngFor="let field of visibleFields">
        <span class="auth-flow__label">{{ fieldLabel(field) }}</span>

        <input
          *ngIf="field.type === 'checkbox'"
          type="checkbox"
          [formControlName]="field.name"
          [attr.aria-invalid]="isInvalid(field) ? 'true' : null"
        />

        <select
          *ngIf="field.type !== 'checkbox' && fieldOptions(field).length"
          [formControlName]="field.name"
          [attr.aria-invalid]="isInvalid(field) ? 'true' : null"
        >
          <option *ngFor="let option of fieldOptions(field)" [value]="option.value">{{ option.label }}</option>
        </select>

        <input
          *ngIf="field.type !== 'checkbox' && !fieldOptions(field).length"
          [type]="inputType(field)"
          [formControlName]="field.name"
          [class.auth-flow__code-input]="isCodeField(field)"
          [autocomplete]="field.autocomplete || 'off'"
          [attr.inputmode]="inputMode(field)"
          [attr.minlength]="field.minLength"
          [attr.maxlength]="field.maxLength"
          [attr.readonly]="field.readOnly ? '' : null"
          [attr.aria-invalid]="isInvalid(field) ? 'true' : null"
        />

        <small class="auth-flow__error" *ngIf="isInvalid(field)">
          {{ fieldLabel(field) }} does not meet the required format.
        </small>
      </label>

      <button type="submit" class="primaryButton full-width" [disabled]="busy">
        {{ busy ? 'Checking…' : 'Continue' }}
      </button>
    </form>

    <div class="auth-flow__methods" *ngIf="authenticationMethods.length">
      <h3 class="auth-flow__subtitle typog-sm">Try another way</h3>
      <button
        type="button"
        class="tertiaryButton"
        *ngFor="let method of authenticationMethods"
        [disabled]="busy"
        (click)="onSelectMethod(method.id)"
      >
        {{ method.label }}
      </button>
    </div>

    <div class="auth-flow__actions" *ngIf="alternativeActions.length">
      <button
        type="button"
        class="tertiaryButton"
        *ngFor="let action of alternativeActions"
        [disabled]="isActionDisabled(action)"
        (click)="onAction(action)"
      >
        {{ actionLabel(action) }}
        <span *ngIf="action.name === 'resend_code' && resendCooldown > 0"> ({{ resendCooldown }}s)</span>
      </button>
    </div>
  </ng-container>

  <p *ngIf="busy && !step && !deadEndMessage && !succeeded" class="auth-flow__hint">Starting sign-in…</p>
</div>
